import { gql } from '@apollo/client';

export const GET_ALL_BLOG_POSTS_QUERY = gql`
  fragment CommonBlogPostFieldsForCollection on BlogPost {
    id
    locale
    title
    content
    appSortOrder
    website
    hidden
    bannerImage {
      id
      url
      formats
    }
  }

  query GetAllBlogPosts($hotelId: ID!) {
    hotel(id: $hotelId) {
      id
      blogPosts {
        ...CommonBlogPostFieldsForCollection
        localizations {
          ...CommonBlogPostFieldsForCollection
        }
      }
    }
  }
`;
